import { dateToLocale } from 'utils/date'

export default function ReportPeriod({ value }) {
  if (!value) {
    return null
  }

  if (typeof value === 'string') {
    return value
  }

  if (value.text) {
    return value.text
  }

  return [value.startDate, value.endDate].filter(Boolean).map(dateToLocale).join(' to ')
}
